import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-important-doc',
  templateUrl: './important-doc.component.html',
  styleUrls: ['./important-doc.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ImportantDocComponent implements OnInit {

  public contentHeader;
  public category = [];
  constructor(public _formBuilder: FormBuilder) { }
  public impDocumentForm: FormGroup;
  documentURL: any;
  ngOnInit(): void {
    this.documentURL = environment.documentURL;
    this.impDocumentForm = this._formBuilder.group({
      catagortyType: [1, ],
    });

    this.category = [ {categoryName:'Solar', categoryID:1}, 
                      {categoryName:'Wind', categoryID:2}, 
                      {categoryName:'Small Hydro', categoryID:3},
                      {categoryName:'Waste to Energy', categoryID:4},
                      {categoryName:'Bio Energy', categoryID:5}];
    this.contentHeader = {
      headerTitle: 'Important Doc',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Important Doc',
            isLink: true,
            link: '/imp-doc'
          }
        ]
      }
    };
  }

  get f() {
    return this.impDocumentForm.controls;
  }

  onOptionsSelected(value) {
		let data = value;
		
	}

}
